import { useQuery } from "@apollo/client";
import {
  GetMeetingForExtensionQueryQuery,
  GetMeetingForExtensionQueryQueryVariables,
} from "types/graphql-schema";

import MeetingBot from "@apps/meeting-new/components/meeting-bot";
import { MeetingPageContent } from "@apps/meeting-new/components/meeting-page";
import { MeetingPageContext } from "@apps/meeting-new/components/meeting-page-context";
import Container from "@components/container/container";
import Error from "@components/error/error";
import GraphqlError from "@components/error/graphql-error";
import AppLink from "@components/link/link";
import Loading from "@components/loading/loading";

import getMeetingForExtensionQuery from "../graphql/get-meeting-for-extension-query";

const ExtensionMeetingContent = ({ meetingId }: { meetingId: number }) => {
  const { loading, error, data } = useQuery<
    GetMeetingForExtensionQueryQuery,
    GetMeetingForExtensionQueryQueryVariables
  >(getMeetingForExtensionQuery, {
    variables: { meetingId },
  });
  const meeting = data?.meeting;
  const meetingGroup = data?.meeting?.meetingGroup;

  // Renders
  if (error) {
    return (
      <Container>
        <div className="mx-4">
          <GraphqlError
            error={error}
            whatDidNotWork="The meeting could not be loaded."
          />
        </div>
      </Container>
    );
  }
  if (!data && loading) {
    return (
      <Container>
        <Loading />
      </Container>
    );
  }

  if (!meetingId || !data || !meeting || !meetingGroup?.id) {
    return (
      <Container>
        <div className="mx-4">
          <Error title="No meetings associated with this Google Meet." />
        </div>
        <div className="mt-6 mx-4 flex justify-center">
          <AppLink
            to="/extension/meetings"
            className="text-blue-800 hover:underline"
          >
            View today's meetings
          </AppLink>
        </div>
      </Container>
    );
  }

  return (
    <div>
      <div className="bg-gray-50 flex justify-between gap-4 px-4 py-2 border-b min-w-0">
        <MeetingBot
          meeting={meeting}
          statusClassName="min-w-0 flex-1"
          compact={true}
        />
      </div>
      <div className="bg-white p-4">
        <MeetingPageContext.Provider
          value={{
            isInSidebar: false,
            isInExtension: true,
          }}
        >
          <MeetingPageContent
            meetingGroupId={meetingGroup.id}
            meeting={meeting}
          />
        </MeetingPageContext.Provider>
      </div>
    </div>
  );
};

export default ExtensionMeetingContent;
